module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'd0whjxwc',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
